export default __webpack_public_path__ + "static/media/med_box.45878a99.png";